function convertLiterToCubicFoot(num) {
  let eq =
    "Converting " +
    num +
    " liter to cubic foot: \n" +
    num +
    " * 0.03531466672 = ";
  let rep = num * 0.03531466672;
  return eq + rep.toFixed(4);
}

function convertLiterToCubicInch(num) {
  let eq =
    "Converting " +
    num +
    " liter to cubic inch: \n" +
    num +
    " * 61.02374409 = ";
  let rep = num * 61.02374409;
  return eq + rep.toFixed(3);
}

function convertLiterToCubicMeter(num) {
  let eq =
    "Converting " +
    num +
    " liter to cubic meter: \n" +
    num +
    " * 0.001 = ";
  let rep = num * 0.001 ;
  return eq + rep.toFixed(5);
}

function convertLiterToCubicMile(num) {
  let eq =
    "Converting " +
    num +
    " liter to cubic mile: \n" +
    num +
    " * 2.399127586e-13 = ";
  let rep = num * 2.399127586e-13;
  return eq + rep.toFixed(13);
}

function convertLiterToCubicYard(num) {
  let eq =
    "Converting " +
    num +
    " liter to cubic yard: \n" +
    num +
    " * 0.001307950619 = ";
  let rep = num * 0.001307950619 ;
  return eq + rep.toFixed(5);
}

export {
  convertLiterToCubicYard,
  convertLiterToCubicMile,
  convertLiterToCubicMeter,
  convertLiterToCubicInch,
  convertLiterToCubicFoot
};
